<div class="popover-with-header">
  <div class="popover-title subtitle-03">
    <div class="popover-title-label-with-icon" *ngIf="dialogTitle">
      <mat-icon class="material-symbols-outlined" [inline]="true"
        >flag
      </mat-icon>
      <span>{{ dialogTitle }}</span>
    </div>
    <button mat-icon-button (click)="dialogClose.emit()">
      <mat-icon class="material-symbols-outlined"
        >{{ closeButtonIcon }}
      </mat-icon>
    </button>
  </div>
  <ng-content></ng-content>
</div>
